import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ICustomer } from '../../../shared/models/index';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { StorageManagerService } from '../../../shared/services/index';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent implements OnInit, OnDestroy {

  // some of the variables are getting set from the parent components.
  // please don't remove any variables.
  loggedIn: boolean;
  isExpanded = false;
  isSecondaryExpanded = false;
  hasCurrentCustomer = false;
  viewFilesMenu = false;
  uploadFilesMenu = false;
  inventoryPageMenu = false;
  selectedCustomer: string;
  subscription: Subscription;
  userData: any;
  isAuthorized: boolean;
  customers: any[] = [];
  permissionsSet: string[];
  customerId: number;

  @Input() activeLink: string;
  @Input() currentCustomer: ICustomer;
  @Input() userName: string;
  @Input() email: string;

  @Output() companySelectionModalOutput = new EventEmitter<boolean>();
  @Output() showDataScopeSelectionOutput = new EventEmitter<boolean>();
  @Output() navigateToOutput = new EventEmitter<string>();

  accessPermissions: any;
  dataScopeName: string;
  dataScope: string;
  dataScopeId: number;
  language = 'English';
  pageUrl: string;
  apiAccessPermitted = false;
  exportDataPermitted = false;

  constructor (private authenticationService: AuthenticationService,
    private storageManagerService: StorageManagerService, private router: Router, private cdRef: ChangeDetectorRef) {
  }

  skipNavigation(e) {

    const type = e.type;

    if (type === 'click' ||
      (type === 'keydown' && (e.which === 13 || e.keyCode === 13))) {

      const main = document.getElementById('main-heading');

      if (main) {
        main.focus();
      }

      e.preventDefault();
      e.stopPropagation();
    }
  }

  logout() {

    let accessPermissions;

    accessPermissions = this.storageManagerService.read('accessPermissions');

    if (accessPermissions) {
      this.authenticationService.captureLogoutEvent(this.email)
        .subscribe(res => {
          this.authenticationService.logout();
          this.storageManagerService.clearAll();
        },
          error => console.error(error));
    } else {
      this.authenticationService.logout();
      this.storageManagerService.clearAll();
    }

  }

  isRouteActive(url): string {

    if (url === '#' || url === '/') {
      url = '/home';
    }

    if (this.activeLink === url || (this.activeLink === '/' && url === '/home')) {
      return 'router-link-active';
    }

    return '';
  }

  ngOnInit() {

    this.pageUrl = location.pathname;

    this.authenticationService.getUserData().subscribe(userData => {
      if (userData) {
        const sessionCustomers = this.storageManagerService.read('eligibleCustomers');
        const sessionCurrentCustomer = this.storageManagerService.read('currentCustomer');
        this.userData = userData;

        this.dataScope = this.storageManagerService.read('dataScope');

        if (sessionCustomers) {

          this.customers = sessionCustomers;
          if (sessionCurrentCustomer) {
            this.currentCustomer = !this.currentCustomer ? (typeof sessionCurrentCustomer === 'object' ? sessionCurrentCustomer : JSON.parse(sessionCurrentCustomer)) : this.currentCustomer;
          }
        }
      }
    });

    (document.activeElement as HTMLElement).blur();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  openCompanySelectionModal(value) {
    this.companySelectionModalOutput.emit(value);
  }

  navigateTo(url) {

    if (this.storageManagerService.read('dataScope') || (!url.includes('/inventory') && !url.includes('/managesubmissionitems') && !url.includes('/submissionhistory'))) {
      this.navigateToOutput.emit(url);
      this.showDataScopeSelectionOutput.emit(false);
      this.router.navigate([url]);
    } else {

      if (url.includes('/inventory') || url.includes('/managesubmissionitems') || url.includes('/submissionhistory')) {
        this.navigateToOutput.emit(url);
        this.showDataScopeSelectionOutput.emit(true);

      } else {
        this.showDataScopeSelectionOutput.emit(false);
      }

      this.openCompanySelectionModal(true);
    }
  }

  displayDataScope(): boolean {

    let retVal = false;

    this.dataScope = this.storageManagerService.read('dataScope');

    const urlsToDisplayLink = ['/inventory', '/managesubmissionitems', '/submissionhistory', '/submissionhistoryitem', '/submissionitemdetails', '/itemdetails'];

    const complexUrl = location.pathname.trim().split('/');

    // the complex url after the split looks like this: ['', 'managedi', 'itemdetails', '45f74b9c-4ded-bd6e-d758-9ad5c1a106c9']
    const url = complexUrl[2] ? complexUrl[2] : complexUrl[1];

    // could be just ['', 'home']
    if (urlsToDisplayLink.includes(`/${ location.pathname }`) || urlsToDisplayLink.indexOf(`/${ url }`) >= 0 && this.dataScope) {
      retVal = true;
    }

    return retVal;
  }

  displayChangeSelectionLink(): boolean {

    let retVal = false;
    const urlsToDisplayLink = ['/inventory', '/managesubmissionitems', '/submissionhistory'];

    const cust = this.storageManagerService.read('currentCustomer');

    let customer: ICustomer;

    if (cust) {
      customer = typeof cust === 'object' ? cust : JSON.parse(cust);
    }

    this.customers = this.storageManagerService.read('eligibleCustomers');

    if (this.customers && this.customers.length) {

      const complexUrl = location.pathname.trim().split('/');

      const url = complexUrl[2] ? complexUrl[2] : complexUrl[1];

      // the complex url after the split looks like this: ['', 'managedi', 'itemdetails', '45f74b9c-4ded-bd6e-d758-9ad5c1a106c9']
      // if (urlsToDisplayLink.includes(`/${ url }`) && (this.customers.length === 1 && customer.applicationVariants.length > 1) || (urlsToDisplayLink.includes(`/${url}`) && this.customers.length > 1) || this.customers.length > 1) {
      //   retVal = true;
      // }

      if (this.customers.length > 1 || urlsToDisplayLink.includes(`/${ url }`) && (this.customers.length === 1 && customer.applicationVariants.length > 1)) {
        retVal = true;
      }
    }

    return retVal;
  }

  init(navigateTo) {

    if (navigateTo !== 'submissionhistory') {
      this.storageManagerService.remove('submissionHistoryTab');
    }

    if (navigateTo !== 'clientsettings') {
      this.storageManagerService.remove('clientAdminTab');
    }
  }

  toggle() {
    const element = document.getElementById('mainNavbar');
    element.classList.toggle('navbar-collapse');
  }

  navbarButtonClicked() {
    this.isExpanded = !this.isExpanded;
  }

  navbarLinkClicked() {

    if (this.isExpanded) {
      const element = document.getElementById('collapsibleNavbar');
      element.classList.remove('show');

      this.isExpanded = false;
    }
  }
}
